"use client";

import "./bfsi.css";
import { Fragment, useEffect } from "react";

/* =========================================================
   DATA
========================================================= */

const questions = [
  "Why is finance close taking too long?",
  "Where is procurement spend increasing?",
  "Can we get one trusted enterprise view?",
  "Which operational exceptions need attention?",
  "Where are workforce skill gaps?",
  "How can we manage customer relationships without surrendering sensitive data to an external CRM?",
  "How can AI work securely with enterprise data?",
  "What should the CXO know today that sits across ten different systems?",
  "How do we improve cost-to-serve?",
  "How do we strengthen compliance and control?",
];

const solutions = [
  {
    title: "Enterprise Transformation",
    href: "/enterprise-transformation",
    image: "/assets/images/Enterprise-transforamtion.jpg",
    text: "S/4HANA | Finance | Procurement | Assets | Projects | BTP | Integration",
  },
  {
    title: "Human Transformation",
    href: "/enterprise-transformation/successfactors",
    image: "/assets/images/people-change-business.jpg",
    text: "SuccessFactors | Employee Experience | Talent | Performance | Learning | Workforce Intelligence",
  },
  {
    title: "Data & Intelligence",
    href: "/datasap",
    image: "/assets/images/data_sap_bdc.jpg",
    text: "Enterprise Data | SAP BDC | Data Science | ML | AI | Decision Intelligence",
  },
  {
    title: "Sovereign CRM & Customer Engagement",
    href: "/coming-soon",
    image: "/assets/images/herocustomer.jpg",
    text: "Customer 360 | Relationship Management | Service | Workflow | AI Agents | Locally Controlled Data | On-prem / Sovereign Deployment",
  },
  {
    title: "Operate & Improve",
    href: "/Operate",
    image: "/assets/images/Operate_improve.jpg",
    text: "AMS | Applications | Integrations | Data Operations | Controls | Automation | Continuous Improvement",
  },
];

const architectureSystems = [
  ["ERP", "Finance | Procurement | Assets | Projects", "database"],
  ["People", "SuccessFactors | Talent | Learning | Workforce Intelligence", "people"],
  ["Data & AI", "SAP BDC | Analytics | Data Science | ML", "chart"],
  ["Sovereign CRM", "Customer 360 | Service | Workflow", "crm"],
];

const integrationItems = [
  ["layers", "Unified Data Model"],
  ["shield", "Security & Compliance"],
  ["network", "API Ecosystem"],
  ["database", "Data Governance"],
];

const workedQuestion = [
  ["01", "Data from", "ERP & Subsidiaries", "/assets/images/Enterprise-transforamtion.jpg"],
  ["02", "Reconciliations", "& Intercompany", "/assets/images/business-problem.jpg"],
  ["03", "Exception", "Identification", "/assets/images/ILLUSTRATIVE-USE-CASE.jpg"],
  ["04", "Root Cause", "Analysis", "/assets/images/manual-month.jpg"],
];

const workedOutcomes = [
  ["zap", "FASTER CLOSE"],
  ["chart", "FEWER EXCEPTIONS"],
  ["shield", "BETTER CONTROL"],
];

const problems = [
  ["01", "Finance close taking too long"],
  ["03", "Procurement spend increasing"],
  ["06", "Operational exceptions rising"],
  ["09", "Cost-to-serve increasing"],
  ["12", "Customer profitability unclear"],
  ["18", "Compliance and control weaknesses"],
  ["21", "Lack of trusted enterprise view"],
  ["24", "Growth opportunity in existing customers"],
  ["27", "Data scattered across systems"],
  ["31", "Limited use of data and AI"],
];

const systems = [
  ["SAP", "database"],
  ["SuccessFactors", "people"],
  ["BDC / Data Platform", "database"],
  ["Other Source Systems", "layers"],
  ["Sovereign CRM", "crm"],
  ["DML / Compliance", "shield"],
  ["External Data", "globe"],
];

/* =========================================================
   ICON SYSTEM
========================================================= */

function Icon({ type }) {
  const common = {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  const icons = {
    database: (
      <>
        <ellipse cx="12" cy="5" rx="8" ry="3" />
        <path d="M4 5v14c0 1.7 3.6 3 8 3s8-1.3 8-3V5" />
        <path d="M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3" />
      </>
    ),

    people: (
      <>
        <circle cx="9" cy="8" r="3" />
        <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
        <circle cx="17" cy="9" r="2.5" />
        <path d="M15.5 14a5 5 0 0 1 5.5 5" />
      </>
    ),

    chart: (
      <>
        <path d="M4 20V11" />
        <path d="M10 20V6" />
        <path d="M16 20V9" />
        <path d="M22 20V3" />
      </>
    ),

    crm: (
      <>
        <circle cx="12" cy="8" r="3" />
        <path d="M5 20c0-3.4 3.1-6 7-6s7 2.6 7 6" />
        <path d="M4 5h2M18 5h2" />
      </>
    ),

    settings: (
      <>
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.8 1.8 0 0 0 .3 2l.1.1-1.8 1.8-.1-.1a1.8 1.8 0 0 0-2-.3 1.8 1.8 0 0 0-1.1 1.7v.2h-2.6v-.2a1.8 1.8 0 0 0-1.1-1.7 1.8 1.8 0 0 0-2 .3l-.1.1-1.8-1.8.1-.1a1.8 1.8 0 0 0 .3-2 1.8 1.8 0 0 0-1.7-1.1h-.2v-2.6h.2a1.8 1.8 0 0 0 1.7-1.1 1.8 1.8 0 0 0-.3-2l-.1-.1 1.8-1.8.1.1a1.8 1.8 0 0 0 2 .3 1.8 1.8 0 0 0 1.1-1.7v-.2h2.6v.2a1.8 1.8 0 0 0 1.1 1.7 1.8 1.8 0 0 0 2-.3l.1-.1 1.8 1.8-.1.1a1.8 1.8 0 0 0-.3 2 1.8 1.8 0 0 0 1.7 1.1h.2v2.6h-.2a1.8 1.8 0 0 0-1.7 1.1z" />
      </>
    ),

    layers: (
      <>
        <path d="M12 3 3 8l9 5 9-5-9-5z" />
        <path d="M3 13l9 5 9-5" />
        <path d="M3 17l9 5 9-5" />
      </>
    ),

    shield: (
      <>
        <path d="M12 3 20 6v5c0 5-3.4 8.8-8 10-4.6-1.2-8-5-8-10V6l8-3z" />
        <path d="m8.5 12 2.2 2.2 4.8-5" />
      </>
    ),

    globe: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18" />
        <path d="M12 3c2.5 2.5 3.5 5.5 3.5 9S14.5 18.5 12 21" />
        <path d="M12 3c-2.5 2.5-3.5 5.5-3.5 9S9.5 18.5 12 21" />
      </>
    ),

    arrow: (
      <>
        <path d="M4 12h15" />
        <path d="m13 6 6 6-6 6" />
      </>
    ),

    zap: (
      <>
        <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8z" />
      </>
    ),

    network: (
      <>
        <circle cx="12" cy="5" r="2.3" />
        <circle cx="5" cy="18" r="2.3" />
        <circle cx="19" cy="18" r="2.3" />
        <path d="M12 7.3 7 15.7" />
        <path d="M12 7.3 17 15.7" />
        <path d="M7.3 18h9.4" />
      </>
    ),
  };

  return <svg {...common}>{icons[type] || icons.layers}</svg>;
}

/* =========================================================
   PAGE
========================================================= */

export default function BFSIPage() {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".bfsi-page .bfsi-reveal"
    );

    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -25px 0px",
      }
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="bfsi-page">

      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="bfsi-hero">

        <div className="bfsi-hero-pattern" />

        <div className="bfsi-container">

          <div className="bfsi-hero-content bfsi-reveal">

           

            <h1>
              Modernise the Enterprise<br/> Around the Core.
            </h1>

            <h2>
              ERP. People. Data. AI. Sovereign CRM.
            </h2>

            <p>
              Orane helps banks, NBFCs and insurers connect and
              modernise the enterprise capabilities surrounding
              the core — finance, procurement, people, data,
              customer engagement and intelligence.
            </p>

            <div className="bfsi-hero-actions">

              <a
                href="/tellusyourproblem#tell-details"
                className="bfsi-btn bfsi-btn-primary"
              >
                Tell Us Your BFSI Problem
                <Icon type="arrow" />
              </a>

              <a
                href="#solutions"
                className="bfsi-btn bfsi-btn-outline"
              >
                See How It Works
              </a>

            </div>

            <div className="bfsi-hero-stats">

              <div>
                <div className="bfsi-hero-stat-icon">
                  <Icon type="shield" />
                </div>
                <span>Better<br />Control</span>
              </div>

              <div>
                <div className="bfsi-hero-stat-icon">
                  <Icon type="chart" />
                </div>
                <span>Greater<br />Efficiency</span>
              </div>

              <div>
                <div className="bfsi-hero-stat-icon">
                  <Icon type="database" />
                </div>
                <span>Stronger<br />Compliance</span>
              </div>

              <div>
                <div className="bfsi-hero-stat-icon">
                  <Icon type="people" />
                </div>
                <span>More Value<br />from Data</span>
              </div>

            </div>

          </div>

        </div>

      </section>

      {/* =====================================================
          QUESTIONS
      ===================================================== */}

      <section
        className="bfsi-section"
        id="questions"
      >

        <div className="bfsi-container">

          <div className="bfsi-questions-card bfsi-reveal">

            <div className="bfsi-questions-content">

              <div className="bfsi-section-heading">

                <h2>The Questions BFSI Leaders Ask</h2>

                <p>Real Questions. Real Decisions. Real Impact.</p>

              </div>

              <div className="bfsi-questions-list">

                {questions.map((question, index) => (
                  <div
                    className="bfsi-question-item bfsi-reveal"
                    key={question}
                  >

                    <span className="bfsi-question-number">
                      {String(index + 1).padStart(2, "0")}
                    </span>

                    <p>{question}</p>

                    <span className="bfsi-question-arrow" aria-hidden="true">
                      <Icon type="arrow" />
                    </span>

                  </div>
                ))}

              </div>

              <a href="#solutions" className="bfsi-questions-more">
                View All Questions
                <Icon type="arrow" />
              </a>

            </div>

            <div className="bfsi-questions-image">
              <img src="/assets/images/BFSI.png" alt="Banking, Financial Services & Insurance" />
            </div>

          </div>

        </div>

      </section>

      {/* =====================================================
          SOLUTIONS
      ===================================================== */}

      <section
        className="bfsi-section"
        id="solutions"
      >

        <div className="bfsi-container">

          <div className="bfsi-section-heading bfsi-reveal">

            <span>Our Solutions For BFSI</span>

            <h2>
              Five Integrated Capability Areas. One Connected Enterprise.
            </h2>

          </div>

          <div className="bfsi-solutions-grid">

            {solutions.map((solution) => (
              <article
                className="bfsi-solution-card bfsi-reveal"
                key={solution.title}
              >

                <div className="bfsi-solution-content">

                  <h3>
                    {solution.title}
                  </h3>

                  <p>
                    {solution.text}
                  </p>

                  <a href={solution.href} className="bfsi-solution-link">
                    Learn more
                    <Icon type="arrow" />
                  </a>

                </div>

                <div className="bfsi-solution-media">
                  <img src={solution.image} alt={solution.title} />
                  <span className="bfsi-solution-dot" />
                </div>

              </article>
            ))}

          </div>

        </div>

      </section>

      {/* =====================================================
          ARCHITECTURE
      ===================================================== */}

      <section className="bfsi-section" id="architecture">

        <div className="bfsi-container">

          <div className="bfsi-section-heading bfsi-reveal">

            <span>Connected Enterprise Architecture</span>

            <h2>
              Work Around the Core to Create Enterprise Value.
            </h2>

          </div>

          <div className="bfsi-architecture bfsi-reveal">

            <div className="bfsi-architecture-existing">

              <div className="bfsi-architecture-existing-text">

                <span className="bfsi-architecture-label">
                  EXISTING CORE
                </span>

                <strong>
                  Core Banking
                </strong>

                <p>
                  Lending&nbsp; • &nbsp;Payments&nbsp; • &nbsp;Cards&nbsp; •
                  &nbsp;Digital Channels&nbsp; • &nbsp;Other Systems
                </p>

              </div>

              <div className="bfsi-architecture-existing-icon">
                <Icon type="database" />
              </div>

            </div>

            <div className="bfsi-architecture-connector">
              <i />
              <span>INTEGRATE</span>
              <i />
            </div>

            <div className="bfsi-architecture-layer">

              <div className="bfsi-architecture-layer-text">

                <span className="bfsi-architecture-label">
                  INTEGRATION & DATA LAYER
                </span>

                <strong>
                  APIs&nbsp; • &nbsp;Data&nbsp; • &nbsp;Security&nbsp; • &nbsp;Governance
                </strong>

              </div>

              <div className="bfsi-architecture-layer-items">

                {integrationItems.map(([icon, label]) => (
                  <div
                    className="bfsi-architecture-layer-item"
                    key={label}
                  >
                    <Icon type={icon} />
                    <span>{label}</span>
                  </div>
                ))}

              </div>

            </div>

            <div className="bfsi-architecture-grid">

              {architectureSystems.map(
                ([title, text, icon]) => (
                  <div
                    className="bfsi-architecture-card bfsi-reveal"
                    key={title}
                  >

                    <div className="bfsi-architecture-card-icon">
                      <Icon type={icon} />
                    </div>

                    <h3>
                      {title}
                    </h3>

                    <p>
                      {text}
                    </p>

                    <span className="bfsi-architecture-card-connect">
                      CONNECT
                      <Icon type="arrow" />
                    </span>

                  </div>
                )
              )}

            </div>

            <div className="bfsi-architecture-bands">

              <div className="bfsi-architecture-context">

                <Icon type="people" />

                <div className="bfsi-architecture-band-text">

                  <span>
                    ENTERPRISE CONTEXT
                  </span>

                  <strong>
                    Customer&nbsp; • &nbsp;Product&nbsp; • &nbsp;Employee&nbsp; •
                    &nbsp;Supplier&nbsp; • &nbsp;Asset&nbsp; • &nbsp;Project&nbsp; •
                    &nbsp;Cost
                  </strong>

                </div>

              </div>

              <div className="bfsi-architecture-intelligence">

                <Icon type="zap" />

                <div className="bfsi-architecture-band-text">

                  <span>
                    AI & INTELLIGENCE
                  </span>

                  <strong>
                    Exceptions&nbsp; • &nbsp;Insights&nbsp; • &nbsp;Agents&nbsp; •
                    &nbsp;Prediction&nbsp; • &nbsp;Recommendations
                  </strong>

                </div>

              </div>

            </div>

            <div className="bfsi-architecture-value">

              <div className="bfsi-architecture-value-step">
                <span className="bfsi-architecture-value-num">01</span>
                <span>DECISION</span>
              </div>

              <i />

              <div className="bfsi-architecture-value-step">
                <span className="bfsi-architecture-value-num">02</span>
                <span>ACTION</span>
              </div>

              <i />

              <div className="bfsi-architecture-value-step">
                <span className="bfsi-architecture-value-num">03</span>
                <strong>BUSINESS VALUE</strong>
              </div>

            </div>

          </div>

        </div>

      </section>

      {/* =====================================================
          WORKED QUESTION
      ===================================================== */}

      <section className="bfsi-section">

        <div className="bfsi-container">

          <div className="bfsi-section-heading bfsi-reveal">

            <span>A Worked Question</span>

            <h2>
              Why Is Finance Close Taking Longer Than Expected?
            </h2>

          </div>

          <div className="bfsi-worked-section">

            <div className="bfsi-worked-flow">

              {workedQuestion.map(
                ([number, title, text, image], index) => (
                  <div
                    className="bfsi-worked-step bfsi-reveal"
                    key={title}
                  >

                    <div className="bfsi-worked-step-top">
                      <span>{number}</span>
                      <strong>{title}</strong>
                      <p>{text}</p>
                    </div>

                    <div className="bfsi-worked-step-image">
                      <img src={image} alt={`${title} ${text}`} />
                    </div>

                    {index < workedQuestion.length - 1 && (
                      <span className="bfsi-worked-step-arrow">
                        <Icon type="arrow" />
                      </span>
                    )}

                  </div>
                )
              )}

            </div>

          </div>

          <div className="bfsi-worked-bottom bfsi-reveal">

            {workedOutcomes.map(([icon, label], index) => (
              <Fragment key={label}>
                <div className="bfsi-worked-outcome">
                  <Icon type={icon} />
                  <strong>{label}</strong>
                </div>

                {index < workedOutcomes.length - 1 && <i />}
              </Fragment>
            ))}

          </div>

        </div>

      </section>

      {/* =====================================================
          BUSINESS PROBLEMS
      ===================================================== */}

      <section className="bfsi-section">

        <div className="bfsi-container">

          <div className="bfsi-section-heading bfsi-reveal">

            <span>Relevant 52 Business Problems</span>

            <h2>
              Key BFSI Questions From Our Problem Library.
            </h2>

          </div>

          <div className="bfsi-problems-layout">

            <div className="bfsi-problems-intro bfsi-reveal">

              <strong>52</strong>

              <h3>
                Business problems
                <br />
                mapped to action.
              </h3>

              <p>
                A structured library of recurring enterprise
                challenges across BFSI operations.
              </p>

              <a href="#systems">
                Explore All 52 Business Problems
                <Icon type="arrow" />
              </a>

            </div>

            <div className="bfsi-problems-grid">

              {problems.map(([number, text]) => (
                <div
                  className="bfsi-problem-card bfsi-reveal"
                  key={number}
                >

                  <span>
                    {number}
                  </span>

                  <p>
                    {text}
                  </p>

                  <Icon type="arrow" />

                </div>
              ))}

            </div>

          </div>

        </div>

      </section>

      {/* =====================================================
          SYSTEMS & DATA
      ===================================================== */}

      <section
        className="bfsi-section"
        id="systems"
      >

        <div className="bfsi-container">

          <div className="bfsi-section-heading bfsi-reveal">

            <h2>
              Enterprise Systems <span>& Data</span>
            </h2>

            <p>
              Bring Data Together. Add Business Context. Deliver Intelligence.
            </p>

          </div>

          <div className="bfsi-enterprise-data">

            <div className="bfsi-systems-grid">

              {systems.map(([name, icon], index) => (
                <div
                  className={`bfsi-system-card bfsi-reveal ${
                    index === 0 ? "bfsi-system-card-primary" : ""
                  }`}
                  key={name}
                >

                  <div className="bfsi-system-icon">
                    <Icon type={icon} />
                  </div>

                  <strong>
                    {name}
                  </strong>

                </div>
              ))}

            </div>

            <div className="bfsi-data-boxes">

              <div className="bfsi-data-box bfsi-reveal">

                <Icon type="database" />

                <div className="bfsi-data-box-text">
                  <strong>Trusted BFSI Data</strong>
                  <span>
                    Transactional | Operational | Master | External
                  </span>
                </div>

              </div>

              <div className="bfsi-data-box bfsi-reveal">

                <Icon type="layers" />

                <div className="bfsi-data-box-text">
                  <strong>Enterprise Semantics & Context</strong>
                  <span>
                    Customer | Product | Employee | Supplier |
                    Asset | Cost | Risk | Compliance
                  </span>
                </div>

              </div>

              <div className="bfsi-data-box bfsi-reveal">

                <Icon type="chart" />

                <div className="bfsi-data-box-text">
                  <strong>BFSI Intelligence</strong>
                  <span>Analytics | AI | Scenarios | Recommendations</span>
                </div>

              </div>

            </div>

          </div>

        </div>

        {/* =====================================================
            FINAL CTA
        ===================================================== */}

        <div
          className="bfsi-final-cta bfsi-reveal"
          id="contact"
        >

          <div className="bfsi-final-cta-inner">

            <div className="bfsi-final-cta-text">

              <h2>
                Modernise Faster.
                <br />
                Control Better. Decide Smarter.
              </h2>

              <a
                href="/tellusyourproblem#tell-details"
                className="bfsi-btn bfsi-btn-primary"
              >
                Tell Us Your BFSI Problem
                <Icon type="arrow" />
              </a>

            </div>

            <div className="bfsi-final-cta-stats">

              <div className="bfsi-final-cta-stat">
                <div className="bfsi-final-cta-stat-icon">
                  <Icon type="shield" />
                </div>
                <span>Better<br />Control</span>
              </div>

              <div className="bfsi-final-cta-stat">
                <div className="bfsi-final-cta-stat-icon">
                  <Icon type="chart" />
                </div>
                <span>Greater<br />Efficiency</span>
              </div>

              <div className="bfsi-final-cta-stat">
                <div className="bfsi-final-cta-stat-icon">
                  <Icon type="database" />
                </div>
                <span>Stronger<br />Compliance</span>
              </div>

              <div className="bfsi-final-cta-stat">
                <div className="bfsi-final-cta-stat-icon">
                  <Icon type="people" />
                </div>
                <span>More Value<br />from Data</span>
              </div>

            </div>

          </div>

        </div>

      </section>

    </main>
  );
}